import { ua } from './modules/ua'
import { realTimeTable } from './modules/realtime'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  current: 'is-current',
  large: 'is-large',
  nav: 'view-nav',
}

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    this.initPages()
  }

  initPages() {
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)

    setTimeout(() => {
      this.body.classList.add(`is-loaded`)
    }, 500)

    // ナビゲーション開閉
    document.querySelector('.nav-trigger').addEventListener('click', () => {
      document.querySelector('body').classList.toggle(klass.nav)
    })

    // ナビゲーションを押下時に閉じる
    Array.from(document.querySelectorAll('.gNav a')).forEach((trigger) => {
      trigger.addEventListener('click', () => {
        document.querySelector('body').classList.toggle(klass.nav)
      })
    })

    if (this.body.classList.contains('page-guideline') || this.body.classList.contains('page-booth')) {
      const selectGuide = document.querySelector('[name="selectGuide"]')
      selectGuide.addEventListener('change', (e) => {
        e.preventDefault()

        const targetId = e.target.value
        const targetElement = document.querySelector(targetId)
        const rectTop = targetElement.getBoundingClientRect().top
        const offsetTop = window.pageYOffset
        const top = rectTop + offsetTop - 100
        window.scrollTo({
          top,
          behavior: 'smooth',
        })
      })

      const isMobileWindowSize = window.matchMedia('(min-width: 768px)')

      const sideNavFixed = () => {
        if (isMobileWindowSize.matches) {
          const { scrollY, pageYOffset } = window
          const sideNav = document.querySelector('.guideMenu')
          const sideNavHeight = sideNav.clientHeight
          const guide = document.querySelector('.guide-wrapper')
          const guideTop = guide.getBoundingClientRect().top + pageYOffset - 152
          const footerTop = document.querySelector('.top__banner').getBoundingClientRect().top + scrollY - sideNavHeight - 152

          if (scrollY > footerTop) {
            sideNav.classList.remove('is-fixed')
            sideNav.classList.add('is-bottom')
          } else if (scrollY > guideTop) {
            sideNav.classList.add('is-fixed')
            sideNav.classList.remove('is-bottom')
          } else {
            sideNav.classList.remove('is-fixed')
            sideNav.classList.remove('is-bottom')
          }
        }
      }
      window.addEventListener('load', sideNavFixed)
      window.addEventListener('scroll', sideNavFixed)
      window.addEventListener('resize', sideNavFixed)
    }

    const videoTrigger = document.querySelectorAll('.videoTrigger')
    const videoCloseTrigger = document.querySelectorAll('.modal-close')
    if (videoTrigger.length > 0) {
      Array.from(videoTrigger).forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault()
          const youtubeID = e.target.getAttribute('data-id')
          const parm = youtubeID === 'i9APcGukDKY' ? '&start=180' : ''

          document.querySelector('.modalMovie .message-body').innerHTML =
            '<figire class="video-container"><iframe width="960" height="500" src="https://www.youtube.com/embed/' +
            youtubeID +
            '?rel=0&autoplay=true' +
            parm +
            '" frameborder="0" allowfullscreen></iframe></figire>'
          document.querySelector('.modalMovie').classList.add('is-active')
        })
      })
      Array.from(videoCloseTrigger).forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault()
          document.querySelector('.modalMovie .message-body').innerHTML = ''
          document.querySelector('.modalMovie').classList.remove('is-active')
        })
      })
    }

    // Timetableページのみ適用
    if (this.body.classList.contains('page-timetable')) {
      const ttTab = document.querySelectorAll('.timeTableDay')
      const ttImg = document.querySelectorAll('.timeTableImg')
      if (ttTab.length > 0) {
        Array.from(ttTab).forEach((trigger, n, t) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault()
            Array.from(ttTab).forEach((tab) => tab.classList.remove(klass.selected))
            Array.from(ttImg).forEach((img) => img.classList.remove(klass.selected))
            trigger.classList.add(klass.selected)
            document.querySelector(trigger.getAttribute('data-id')).classList.add(klass.selected)
          })
        })
      }

      const largeButton = document.querySelector('.timeTableLargeButton button')
      largeButton.addEventListener('click', (e) => {
        e.preventDefault()
        var _this = largeButton
        _this.classList.toggle(klass.large)

        document.querySelector('.timeTableArea').classList.toggle(klass.large)
        if (_this.classList.contains(klass.large)) {
          _this.innerHTML = '<span>タイムテーブルを元に戻す</span>'
        } else {
          _this.innerHTML = '<span>タイムテーブルを大きくする</span>'
        }
      })
    }

    // Goodsページのみ適用
    if (this.body.classList.contains('page-goods')) {
      const largeButton = document.querySelector('#goodsList .biggerButton')
      largeButton.addEventListener('click', (e) => {
        e.preventDefault()
        document.querySelector('#goodsList').classList.toggle(klass.active)
      })
    }

    if (document.querySelector('#top__timeLine')) {
      realTimeTable()
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.sc23 = new App()
})

//
// window.addEventListener('load', () => {
// })
